import { Component, OnInit } from '@angular/core';
import { FormGroup,FormControl } from '@angular/forms';
import { ServerService } from '../services/server.service';

declare var $:any;
declare var iziToast:any;
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import * as fs from 'file-saver';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exit } from 'process';

@Component({
  selector: 'app-predictivedialer-report',
  templateUrl: './predictivedialer-report.component.html',
  styleUrls: ['./predictivedialer-report.component.css']
})
export class PredictivedialerReportComponent implements OnInit {

  predictive_dailer_rept:any=FormGroup;
  capmaign_name_list;
  uadmin_id;
  adminId;
  admin_permission;
  access_token;
  recordNotFound= false;
  pageLimit = 20;
  paginationData: any = { "info": "hide" };
  offset_count = 0;
  predictive_dailer_list: any;
  predictive_dailer_header: any;
  predictive_dailer_middle_data: any;

  constructor(private serverService: ServerService) { }

  ngOnInit(): void {


   
    this.predictive_dailer_rept = new FormGroup({
      'from_date': new FormControl(null),
      'to_date': new FormControl(null),
      'campaign_type': new FormControl(null)
    });
    this.uadmin_id = localStorage.getItem('userId');
    this.adminId = localStorage.getItem('admin_id');
    this.admin_permission = localStorage.getItem('admin_permision');
    this.access_token = localStorage.getItem('access_token');


    this.campaign_list();
    this.predictiveDailerReportList({});
  }



  searchDatalist(data){
    // alert(this.uadmin_id);
    var list_data = this.listDataInfo(data);
    let api_req: any = new Object();
    let history_req: any = new Object();
    history_req.action = "predictive_dailer_report_list";
    // history_req.search_text = $('#campaign_type').val();
    // history_req.order_by_name = list_data.order_by_name;
    history_req.order_by_type = list_data.order_by_type;
    history_req.limit = list_data.limit;
    history_req.offset = list_data.offset;
    history_req.from_dt = $('#from_date').val();
    history_req.to_dt = $('#to_date').val();
    history_req.admin_id = this.adminId;
    history_req.camp_id = $('#campaign_type').val();
    api_req.operation = "predective_dialer_contact";
    api_req.moduleType = "predective_dialer_contact";
    api_req.api_type = "web";
    api_req.access_token = localStorage.getItem('access_token');
    api_req.element_data = history_req;
    this.serverService.sendServer(api_req).subscribe((response: any) => {
      console.log(response);
      if (response.result.status == 1) {
        
        this.predictive_dailer_list = response.result.data.list_data;
        this.offset_count = list_data.offset;
        this.paginationData = this.serverService.pagination({ 'offset': response.result.data.list_info.offset, 'total': response.result.data.list_info.total, 'page_limit': this.pageLimit });
        this.recordNotFound = this.predictive_dailer_list.length == 0 ? true : false;
      }

    },
      (error) => {
        //console.log(error);
      });

  }
  listDataInfo(list_data) {

    list_data.search_text = list_data.search_text == undefined ? "" : list_data.search_text;
    list_data.order_by_name = list_data.order_by_name == undefined ? "history.id" : list_data.order_by_name;
    list_data.order_by_type = list_data.order_by_type == undefined ? "desc" : list_data.order_by_type;
    list_data.limit = list_data.limit == undefined ? this.pageLimit : list_data.limit;
    list_data.offset = list_data.offset == undefined ? 0 : list_data.offset;
    return list_data;
  }
  predictiveDailerReportList(data) {

    

    // alert(this.uadmin_id);
    var list_data = this.listDataInfo(data);
    let api_req: any = new Object();
    let history_req: any = new Object();
    history_req.action = "predictive_dailer_report_list";
    // history_req.search_text = $('#campaign_type').val();
    // history_req.order_by_name = list_data.order_by_name;
    history_req.order_by_type = list_data.order_by_type;
    history_req.limit = list_data.limit;
    history_req.offset = list_data.offset;
    history_req.from_dt = $('#from_date').val();
    history_req.to_dt = $('#to_date').val();
    history_req.admin_id = this.adminId;
    history_req.camp_id = $('#campaign_type').val();
    api_req.operation = "predective_dialer_contact";
    api_req.moduleType = "predective_dialer_contact";
    api_req.api_type = "web";
    api_req.access_token = localStorage.getItem('access_token');
    api_req.element_data = history_req;
    this.serverService.sendServer(api_req).subscribe((response: any) => {
      console.log(response);
      if (response.result.status == 1) {
        
        this.predictive_dailer_list = response.result.data.list_data;
        this.offset_count = list_data.offset;
        this.paginationData = this.serverService.pagination({ 'offset': response.result.data.list_info.offset, 'total': response.result.data.list_info.total, 'page_limit': this.pageLimit });
        this.recordNotFound = this.predictive_dailer_list.length == 0 ? true : false;
      }

    },
      (error) => {
        //console.log(error);
      });

  }

  getReports(){

  }
  campaign_list(){

    let api_req: any = '{"operation":"predective_dialer_contact","moduleType":"predective_dialer_contact","api_type":"web","access_token":"' + this.access_token + '","element_data":{"action": "campaign_list"}}';

    this.serverService.sendServer(api_req).subscribe((response: any) => {

      if (response.result.status == true) {

     this.capmaign_name_list =response.result.data;

        

      } else {
      }
    },
      (error) => {
        //console.log(error);
      });
  }

  predictive_Dailer_Report(){

   
    let fromDate = $('#from_date').val();
    let to_dt = $('#to_date').val();
    let camp_id = $('#campaign_type').val();


    if (fromDate == null || fromDate == '') {
      iziToast.warning({
        message: "Please Select From Date",
        position: 'topRight'
      });
      return false;
    }

    var currentDate = new Date();
    var selectedToDate = new Date(to_dt);
    var selectedToDate1 = new Date(fromDate);

    if (to_dt == null || to_dt == '') {
      iziToast.warning({
        message: "Please Select a To Date",
        position: 'topRight'
      });
      return false;
    }
    if (to_dt < fromDate || selectedToDate > currentDate || selectedToDate1 > currentDate) {
      iziToast.warning({
        message: "Please Select a Valid Date",
        position: 'topRight'
      });
      return false;
    }

    if (camp_id == null || camp_id == '' || camp_id == 'null') {

      iziToast.warning({
        message: "Please Enter Campaign Type",
        position: 'topRight'
      });
      return false;
    }

    Swal.fire({
      html:
        '<div style="display: flex;justify-content: center;"><div class="pong-loader"></div></div>',
      showCloseButton: false,
      showCancelButton: false,
      showConfirmButton: false,
      focusConfirm: false,
      background: 'transparent',
      allowOutsideClick: false,
    });

   

    
    let api_req: any = '{"operation":"predective_dialer_contact","moduleType":"predective_dialer_contact","api_type":"web","access_token":"' + this.access_token + '","element_data":{"action": "predictive_dailer_report","from_dt":"'+fromDate+'","to_dt":"'+to_dt+'","camp_id":"' + camp_id + '","admin_id":"' + this.adminId + '","order_by_type":"desc"}}';

    this.serverService.sendServer(api_req).subscribe((response: any) => {

      if (response.result.status == true) {

     
        this.predictive_dailer_header =response.result.data.header;
        this.predictive_dailer_middle_data =response.result.data.data;
        
        

         this.predictive_dailer_Report_Excel();


      } else {
      }
    },
      (error) => {
        //console.log(error);
      });

  }

  predictive_dailer_Report_Excel() {



    const ExcelJS = require('exceljs');
    const fs = require('file-saver');
    const workbook = new ExcelJS.Workbook();
    const predictive_dailer = workbook.addWorksheet('Predictive Dailer Report');


    
    const headerweekly = predictive_dailer.addRow(this.predictive_dailer_header);
    headerweekly.eachCell((cell, number) => {

      cell.font = {
        name: 'Calibri',
        family: 4,
        size: 11,
        bold: true,

      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,

      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      const column = predictive_dailer.getColumn(number);
      const contentWidth = (cell.value || '').toString().length + 2;
      if (!column.width || contentWidth > column.width) {
        column.width = contentWidth;
      }
    });
    
    this.predictive_dailer_middle_data.forEach((d) => {
      const row = predictive_dailer.addRow(d);

      row.eachCell((cell, colNumber) => {
        cell.alignment = {
          vertical: 'bottom',
          horizontal: colNumber === 1 ? 'left' : 'right',
        };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
         let content = cell.value;

     

        cell.value = content;

        const column = predictive_dailer.getColumn(colNumber);
        const contentWidth = (cell.value || '').toString().length + 2;
        if (!column.width || contentWidth > column.width) {
          column.width = contentWidth;
        }
      });


    });



       workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      fs.saveAs(blob, 'Predictive Dailer Report.xlsx'); // Assumes 'fs.saveAs' saves the Blob to a file

      this.predictive_dailer_rept.reset();
      Swal.close();
      
    });


    // this.disableReport = true;

    // return false;

  }

}
